// CALL REQUEST creation
export const CALL_REQUEST_CREATION_REQUESTED =
    'CALL_REQUEST_CREATION_REQUESTED';
export const CALL_REQUEST_CREATION_SUCCESS = 'CALL_REQUEST_CREATION_SUCCESS';
export const CALL_REQUEST_CREATION_FAILED = 'CALL_REQUEST_DELETE_FAILED';

// CALL REQUEST cancel
export const CALL_REQUEST_CANCEL_REQUESTED = 'CALL_REQUEST_CANCEL_REQUESTED';
export const CALL_REQUEST_CANCEL_SUCCESS = 'CALL_REQUEST_CANCEL_SUCCESS';
export const CALL_REQUEST_CANCEL_FAILED = 'CALL_REQUEST_CANCEL_FAILED';

// CALL REQUEST finish
export const CALL_REQUEST_FINISH_REQUESTED = 'CALL_REQUEST_FINISH_REQUESTED';
export const CALL_REQUEST_FINISH_FAILED = 'CALL_REQUEST_FINISH_FAILED';
export const CALL_REQUEST_FINISH_SUCCESS = 'CALL_REQUEST_FINISH_SUCCESS';

// CALL REQUEST refresh
export const CALL_REQUEST_REFRESH_REQUESTED =
    'CALL_REQUEST_REFRESH_REQUESTED';
export const CALL_REQUEST_REFRESH_SUCCESS =
    'CALL_REQUEST_REFRESH_SUCCESS';
export const CALL_REQUEST_REFRESH_FAILED =
    'CALL_REQUEST_REFRESH_FAILED';

// CALL REQUEST polling interval
export const CALL_REQUEST_POLLING_INTERVAL_CREATED = 'CALL_REQUEST_POLLING_INTERVAL_CREATED';
export const CALL_REQUEST_POLLING_INTERVAL_REMOVED = 'CALL_REQUEST_POLLING_INTERVAL_REMOVED';

// CALL fetch
export const CALL_FETCH_REQUESTED = 'CALL_FETCH_REQUESTED';
export const CALL_FETCH_SUCCESS = 'CALL_FETCH_SUCCESS';
export const CALL_FETCH_FAILED = 'CALL_FETCH_FAILED';

// CALL remove
export const CALL_REMOVE_SUCCESS = 'CALL_REMOVE_SUCCESS';

// STORES
export const STORES_FETCH_REQUESTED = 'STORES_FETCH_REQUESTED';
export const STORES_FETCH_SUCCESS = 'STORES_FETCH_SUCCESS';
export const STORES_FETCH_FAILED = 'STORES_FETCH_FAILED';

// CUSTOMER (persistent social-login account)
export const CUSTOMER_LOGIN_REQUESTED = 'CUSTOMER_LOGIN_REQUESTED';
export const CUSTOMER_LOGIN_SUCCESS = 'CUSTOMER_LOGIN_SUCCESS';
export const CUSTOMER_LOGIN_FAILED = 'CUSTOMER_LOGIN_FAILED';
export const CUSTOMER_LOGOUT = 'CUSTOMER_LOGOUT';
export const CUSTOMER_ME_SUCCESS = 'CUSTOMER_ME_SUCCESS';

// CUSTOMER history
export const CUSTOMER_CALL_REQUESTS_FETCH_REQUESTED =
    'CUSTOMER_CALL_REQUESTS_FETCH_REQUESTED';
export const CUSTOMER_CALL_REQUESTS_FETCH_SUCCESS =
    'CUSTOMER_CALL_REQUESTS_FETCH_SUCCESS';
export const CUSTOMER_CALL_REQUESTS_FETCH_FAILED =
    'CUSTOMER_CALL_REQUESTS_FETCH_FAILED';
export const CUSTOMER_PURCHASE_ORDERS_FETCH_REQUESTED =
    'CUSTOMER_PURCHASE_ORDERS_FETCH_REQUESTED';
export const CUSTOMER_PURCHASE_ORDERS_FETCH_SUCCESS =
    'CUSTOMER_PURCHASE_ORDERS_FETCH_SUCCESS';
export const CUSTOMER_PURCHASE_ORDERS_FETCH_FAILED =
    'CUSTOMER_PURCHASE_ORDERS_FETCH_FAILED';

// CATALOG (storefront, read-only for the buyer)
export const FEATURED_PRODUCTS_FETCH_REQUESTED =
    'FEATURED_PRODUCTS_FETCH_REQUESTED';
export const FEATURED_PRODUCTS_FETCH_SUCCESS =
    'FEATURED_PRODUCTS_FETCH_SUCCESS';
export const FEATURED_PRODUCTS_FETCH_FAILED = 'FEATURED_PRODUCTS_FETCH_FAILED';
export const STORE_CATALOG_FETCH_REQUESTED = 'STORE_CATALOG_FETCH_REQUESTED';
export const STORE_CATALOG_FETCH_SUCCESS = 'STORE_CATALOG_FETCH_SUCCESS';
export const STORE_CATALOG_FETCH_FAILED = 'STORE_CATALOG_FETCH_FAILED';
export const STORE_PRODUCT_FETCH_REQUESTED = 'STORE_PRODUCT_FETCH_REQUESTED';
export const STORE_PRODUCT_FETCH_SUCCESS = 'STORE_PRODUCT_FETCH_SUCCESS';
export const STORE_PRODUCT_FETCH_FAILED = 'STORE_PRODUCT_FETCH_FAILED';

// CART (stage 3: one cart per store, priced by the API)
export const CARTS_FETCH_REQUESTED = 'CARTS_FETCH_REQUESTED';
export const CARTS_FETCH_SUCCESS = 'CARTS_FETCH_SUCCESS';
export const CARTS_FETCH_FAILED = 'CARTS_FETCH_FAILED';
export const CART_FETCH_REQUESTED = 'CART_FETCH_REQUESTED';
export const CART_FETCH_SUCCESS = 'CART_FETCH_SUCCESS';
export const CART_FETCH_FAILED = 'CART_FETCH_FAILED';
export const CART_ITEM_ADD_REQUESTED = 'CART_ITEM_ADD_REQUESTED';
export const CART_ITEM_ADD_SUCCESS = 'CART_ITEM_ADD_SUCCESS';
export const CART_ITEM_ADD_FAILED = 'CART_ITEM_ADD_FAILED';
export const CART_ITEM_UPDATE_REQUESTED = 'CART_ITEM_UPDATE_REQUESTED';
export const CART_ITEM_UPDATE_SUCCESS = 'CART_ITEM_UPDATE_SUCCESS';
export const CART_ITEM_UPDATE_FAILED = 'CART_ITEM_UPDATE_FAILED';
export const CART_ITEM_REMOVE_REQUESTED = 'CART_ITEM_REMOVE_REQUESTED';
export const CART_ITEM_REMOVE_SUCCESS = 'CART_ITEM_REMOVE_SUCCESS';
export const CART_ITEM_REMOVE_FAILED = 'CART_ITEM_REMOVE_FAILED';
export const CART_CHECKOUT_REQUESTED = 'CART_CHECKOUT_REQUESTED';
export const CART_CHECKOUT_SUCCESS = 'CART_CHECKOUT_SUCCESS';
export const CART_CHECKOUT_FAILED = 'CART_CHECKOUT_FAILED';
// 409/400 del checkout con el carrito fresco en `data`: reemplaza el local
export const CART_CHECKOUT_CONFLICT = 'CART_CHECKOUT_CONFLICT';
export const CART_NOTICE_DISMISSED = 'CART_NOTICE_DISMISSED';
